import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import Button from "../ui/Button";
import { ButtonSize } from "../ComponentsType";
import useAuth from "store/modules/auth/authHook";
import { useAlarmFlag, useTopSelected } from "store/modules/navigates/navigatesHook";
import AlarmPage from "pages/alarm";
import { Grade } from "store/modules/auth/authVo";
import { useDispatch } from "react-redux";
import { rdxSetAlarmPopup } from "store/modules/navigates/navigatesR";
import { useTranslation } from "react-i18next";

export const HeaderContainer = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  top: 0;
  width: 100%;
  height: 56px;
  padding: 0;
  background-color: #fff;
  border-bottom: 1px solid var(--border-normal);

  z-index: 1;

  @media screen and (max-width: 767px) {
    height: 45px;
  }
`;

export const SeerviceWrap = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`;

export const HeaderLogo = styled.h1`
  display: flex;
  align-items: center;
  width: 91.6px;
  margin-left: 20px;
  & a {
    display: block;
  }
  & img {
    display: inline-block;
    width: 100%;
  }
  @media screen and (max-width: 767px) {
    width: 80px;
  }
`;

const GnbWrap = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-right: 30px;
`;

const HeaderBtnWrap = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: end;
  height: 32px;
  gap: 4px;

  button.alarm {
    position: relative;
    &.new::after {
      content: "";
      width: 5px;
      height: 5px;
      background-color: red;
      border-radius: 50%;
      display: block;
      position: absolute;
      top: 5px;
      right: 7px;
    }
  }
`;

const MenuBtn = styled.div<{ isActive: boolean }>`
  position: relative;
  display: flex;
  height: 100%;
  button {
    color: #444;
    font-weight: 500;
    font-size: 14px;
    ${props => (props.isActive === true ? `background-color: var(--secondary); color: #fff` : "")};
    border: 1px solid #fff;
    padding: 6px 14px;
    border-radius: 8px;
    &:hover {
      border: 1px solid var(--secondary);
      background-color: #fff;
      color: var(--secondary);
    }
  }
`;

const AlarmPopWrap = styled.div<{ open: boolean }>`
  position: absolute;
  top: 56px;
  right: ${props => (props.open ? "0px" : "-460px")};
  width: 450px;
  height: 80vh;
  background-color: #fff;
  transition: all 0.3s;
  box-shadow: rgba(0, 0, 0, 0.15) -5px 5px 10px 0px;
  border-left: 1px solid #dedede;
  /* overflow: hidden; */
`;

function HeaderMenu(props: { menu: { menu: string; text: string }; isActive: boolean }) {
  const { logout } = useAuth();
  const nav = useNavigate();

  return (
    <MenuBtn isActive={props.isActive}>
      <Button
        btnSize={ButtonSize.MD}
        btnType="ghost"
        text={props.menu.text}
        onClick={() => {
          if (props.menu.menu === "logout") {
            logout();
          } else if (props.menu.menu === "alarm") {
            // setAlarm(!alarm);
          } else {
            nav(`/admin/${props.menu.menu}`);
          }
        }}
      />
    </MenuBtn>
  );
}

function AlarmPopup(props: { alarmFlag: boolean }) {
  return <AlarmPopWrap open={props.alarmFlag}>{props.alarmFlag === true && <AlarmPage />}</AlarmPopWrap>;
}

function Header(): JSX.Element {
  const { name, getToken, role } = useAuth();
  const getTopSelected = useTopSelected();

  const sTop = getTopSelected();
  const { alarmFlag, isAlarm } = useAlarmFlag();
  const dispatch = useDispatch();

  const { t } = useTranslation();

  const menu = [
    { menu: "notice", text: t("header.notice") },
    { menu: "setting", text: role === Grade.MASTER ? t("header.setting") : t("header.profile") },
    { menu: "logout", text: t("header.logout") },
  ];

  useEffect(() => {
    if (name === "" || name === undefined) {
      getToken();
    }
  }, [role]);

  return (
    <HeaderContainer>
      {/* <GnbWrap isActive={s.router === loc?.pathname}> */}
      <GnbWrap>
        <HeaderBtnWrap>
          {role === Grade.MASTER && (
            <MenuBtn isActive={alarmFlag}>
              <Button
                btnSize={ButtonSize.MD}
                btnType="ghost"
                className={`alarm ${isAlarm === true ? "new" : ""}`}
                text={t("header.alarm")}
                onClick={() => {
                  dispatch(rdxSetAlarmPopup(!alarmFlag));
                }}
              />
            </MenuBtn>
          )}

          {menu.map(i => {
            return <HeaderMenu key={i.menu} menu={i} isActive={i.menu === sTop} />;
          })}
        </HeaderBtnWrap>
        {role === Grade.MASTER && <AlarmPopup alarmFlag={alarmFlag} />}
      </GnbWrap>
    </HeaderContainer>
  );
}

export default React.memo(Header);
